import ReactGA from 'react-ga4'
import { LOCATION_CHANGE } from 'react-router-redux'
import { Dispatch, Middleware, MiddlewareAPI } from 'redux'

const createGoogleAnalyticsMiddleware = () => {
  const googleAnalyticsMiddleware: Middleware = ({ getState }: MiddlewareAPI) => (next: Dispatch) => action => {
    switch (action.type) {
      case LOCATION_CHANGE:
        const pathInfo = action.payload

        ReactGA.send({
          hitType: 'pageview',
          page: `${pathInfo.pathname}${pathInfo.search}`,
          title: `${document.title}`
        })
        break
    }
    return next(action)
  }

  return googleAnalyticsMiddleware
}
export default createGoogleAnalyticsMiddleware
